import TabPage from "./../../factories/tab-page";
import BaseViewModel from "./../../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import TabController from "./../../factories/tab-controller";
import BaoDialog from "./../../factories/bao-dialog";
class ChecklistCategory extends BaseViewModel {
    ChecklistCategoryId: KnockoutObservable<string> = ko.observable<string>(null);
    ChecklistCategoryName: KnockoutObservable<string> = ko.observable("");
    constructor(tabPage: TabPage) {
        super(tabPage);
    }
    CompleteCheck() {
        if (this.ChecklistCategoryName() != null && this.ChecklistCategoryName() != "") {
            return true;
        }
        return false;
    }
    InitUrl() {
        return "ChecklistCategory/Init";
    }
    loaded() {
        super.loaded();
    }
}
export default ChecklistCategory;